import { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { z } from 'zod';

import { Button, Link } from 'components/StyledTemplates/StyledTemplates';

import AlertsService from 'services/AlertsService';
import MarketingSiteService from 'services/MarketingSiteService';

import useResources from 'hooks/useResources';

const EmployerFormSchema = z.object({
    email: z.string().email(),
});

const EmployerForm = () => {
    const { t } = useResources();

    const [pending, setPending] = useState<boolean>(false);

    const handlers = {
        onSubmit: async (e: any) => {
            try {
                setPending(true);
                e.preventDefault();
                setPending(true);
                const formData: Object = Object.fromEntries(new FormData(e.target).entries());
                const validForm = EmployerFormSchema.parse(formData);
                MarketingSiteService.sendEmployeeEmail(validForm.email);
            } catch (error) {
                AlertsService.handleError(error);
            } finally {
                setPending(false);
            }
        },
    };

    const domain = window.location.pathname
        .split('/')
        .filter((i) => i !== '')[1]
        .split('')
        .reverse()
        .join('')
        .replace('-', '.')
        .split('')
        .reverse()
        .join('');

    return (
        <div className="d-flex flex-column w-full">
            <form name="benefit-form" onSubmit={handlers.onSubmit} className="d-flex w-full mb-2">
                <input type="text" name="email" placeholder="Your work email" className="form-control mr-2" />
                <Button
                    data-qaid="send_code_button"
                    type="submit"
                    extra="min-width: 200px; align-items: center; justify-content: center;"
                >
                    {pending ? <Spinner animation="border" size="sm" /> : t('employerForm.sendVerificationCode')}
                </Button>
            </form>
            <Link marketing={false} to={`/signup?employer=${domain}`}>
                {t('employerForm.alreadyHaveAVerificationCode')}
            </Link>
        </div>
    );
};

export default EmployerForm;
